module.exports = __webpack_public_path__ + "static/media/blood-and-imaging-badge.e8f6cfa6.svg";